import getLocalEntityState from './getLocalEntityState';
export default function getRowBeingDragged(entity) {
    var _a;
    return (_a = getLocalEntityState(entity)) === null || _a === void 0 ? void 0 : _a.rowBeingDragged;
}
